/** @jsx jsx */
import { jsx } from '@balance-web/core';
import type { ComponentType } from 'react';
import React from 'react';

export type CreateOptions = {
  /** The name of the illustration. */
  name: string;
  /** Describe the elements of the illustration. */
  description: string;
  /** The height of the illustration. */
  height: number;
  /** The width of the illustration. */
  width: number;
};
export type IllustrationProps = {
  /** The height and width of the illustration. */
  size?: number | string;
};

export const createIllustration = (
  { description, name, height, width }: CreateOptions,
  children: React.ReactNode
) => {
  let Illustration: ComponentType<IllustrationProps> = ({
    size,
  }: IllustrationProps) => {
    return (
      <svg
        css={{
          height: size ? `(calc(${height} / ${width}) * ${size})` : height,
          width: size || width,
        }}
        fill="none"
        focusable="false"
        role="img"
        viewBox={`0 0 ${width} ${height}`}
      >
        <title>{description}</title>
        {children}
      </svg>
    );
  };

  Illustration.displayName = name;

  return Illustration;
};
